import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  accounts$: BehaviorSubject<Object>;
  currentAccount$: BehaviorSubject<Object>;
  accountsList$: BehaviorSubject<Object>;
  accountId$: BehaviorSubject<any>;

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {
    this.accounts$ = new BehaviorSubject(null);
    this.currentAccount$ = new BehaviorSubject(null);
    this.accountsList$ = new BehaviorSubject(null);
    this.accountId$ = new BehaviorSubject(null);
  }

  loadAccounts() {    

    this.accounts$.next({"loading":true,data:[]});
    this.http.get('/api/data/accounts').subscribe(
      (response: any) => {
        const rtn = response;
        this.accounts$.next({"loading":false,data:rtn});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get account');
        console.log(error);
      }
    );
  }

  reloadAccounts(data){
    this.accounts$.next({"loading":false,"filter":true, data:data});
  }

  resetAccounts() {
    this.accounts$.next(null);
  }

  loadCurrentAccount(accountId:number){
    this.currentAccount$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('accountid', accountId.toString())

    this.http.get("/api/data/account",{ params }).subscribe(
      (response: any) => {
        let rtn = response;
        this.currentAccount$.next({"loading":false,data:rtn});
      }, (error: any) => {
        console.log('unable to get account');
        console.log(error);
      }
    );
  }

  resetCurrentAccounts() {
    this.currentAccount$.next(null);
  }

  loadAccountsList() {    

    this.accountsList$.next({"loading":true,data:[]});

    this.http.get("/api/data/accountslist").subscribe(
      (response: any) => {
        const rtn = response;
        this.accountsList$.next({"loading":false,data:rtn});
      }, (error: any) => {
        console.log('unable to get accountslist');
        console.log(error);
      }
    );
  }

  getAccountByClientInfo(filterData: Object) {
    this.accountId$.next({ loading: true, data: [] });

    let filterBy = [];
    if (filterData) {
      Object.keys(filterData).forEach(key => {
        const value = (filterData[key] || '').trim();
        if (value) {
          filterBy.push({
            key,
            value,
            op: 'eq'
          });
        }
      });
    }
    
    const data = {
      filterBy: JSON.stringify(filterBy),
      pageIndex: 1,
      pageSize: 2
    };

    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x, data[x]);
    })
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post('/api/data/accountsdashboard', body.toString(), { headers: headers })
      .subscribe(
        (response: any) => {
          if (response && response.success) {
            let rtn = [];

            const { data: result } = response;
            if (Array.isArray(result) && result.length && result[0].dataitems) {
              rtn = JSON.parse(result[0].dataitems);
            }

            this.accountId$.next({ loading: false, data: rtn });
          }
        }, (error: any) => {
          const message = 'Unable to get account';
          const snackBarRef = this.snackBar.open(message, '', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
          console.log(message + ' > ' + JSON.stringify(error));
        }
      );
  }
}


